import { post, getError } from '../actions/ajax';
import store from '../reducers/storeRegistration';
import loginActions from '../actions/loginActionCreators';
import BehaviorError from '../../behaviors/src/lib/error/behaviorError';

// Simple mapping from entity name to route - avoids circular dependency
const getEntityRoute = entityName => {
  switch (entityName) {
    case 'Creator':
      return 'employees';
    case 'ContractSpec':
      return 'contractspecs';
    case 'JobPhaseCode':
      return 'jobphasecodes';
    case 'contentChange':
      return 'contentChanges';
    case 'formModal':
      return 'forms';
    default:
      return `${entityName.toLowerCase()}s`;
  }
};
const normalizeDebugMessage = errorDebug => {
  if (errorDebug == null) {
    return '';
  }
  if (typeof errorDebug === 'string') {
    return errorDebug.replace(/^DEBUG: /, '').trim();
  }
  if (typeof errorDebug === 'object' && typeof errorDebug.message === 'string') {
    return errorDebug.message.replace(/^DEBUG: /, '').trim();
  }
  return String(errorDebug).trim();
};
const toBehaviorError = e => {
  var _e$response$status, _e$response;
  const errorData = getError(e);
  const debug = normalizeDebugMessage(errorData.error_debug);
  const message = debug || errorData.error_msg || e.message;
  return new BehaviorError(message, (_e$response$status = (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) !== null && _e$response$status !== void 0 ? _e$response$status : 500, undefined, e instanceof Error ? e : undefined);
};
const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext
/* nativeFunctions, */) => {
  const entityRoute = getEntityRoute(entityName);
  const url = `/${entityRoute}/evaluate`;

  // Reduce the content and entity size when making a server request
  // Ideally, content and entity would be further reduced to only the necessary data, but
  // it's challenging to determine what is necessary for the server to evaluate the behavior.
  const limitedEntity = JSON.parse(JSON.stringify(entity));
  delete limitedEntity.content;
  const limitedContent = JSON.parse(JSON.stringify(content));
  const types = ['formType', 'issueType', 'ReportType'];
  types.forEach(type => {
    if (limitedContent[type]) {
      const dataToKeep = {
        name: limitedContent[type].name,
        identifier: limitedContent[type].identifier
      };
      delete limitedContent[type];
      limitedContent[type] = dataToKeep;
    }
    delete limitedEntity[type]; // remove type from entity too
  });
  const postData = {
    source,
    content: limitedContent,
    entity: limitedEntity,
    parentContentPath,
    transientContext
  };
  try {
    const response = await post(url, postData);
    return response.data;
  } catch (e) {
    var _e$response2;
    if (((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 401) {
      try {
        await store.dispatch(loginActions.serverToken());
        const response = await post(url, postData);
        return response.data;
      } catch (retryError) {
        throw toBehaviorError(retryError);
      }
    }
    throw toBehaviorError(e);
  }
};
const serverNativeBehaviorEvaluator = {
  evaluate
};
export default serverNativeBehaviorEvaluator;